import { useParams } from "react-router-dom";
import {
  ElevatoriaStyled,
  BombasStyled,
  StatusBomba,
  BotaoOnOff,
  Switch,
  CxControle,
  EventosFalhasStyled,
  ModalStyledAvisoEmergencia,
} from "../../Styles/Elevatoria";
import { Footer } from "../../components/Footer";
import { Header, HeaderMobil } from "../../components/Header";
import { LogoBG } from "../../components/logoBG";
import { apiSae } from "../../services/api";
import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../../Context/ContextHome";
import { Poco } from "../../components/poco";
import { Nivel } from "../../components/Nivel";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { FaArrowRotateLeft } from "react-icons/fa6";
import helicoidal from "../../Assets/Icons/helicoidal.svg";
import vertical from "../../Assets/Icons/deslocamentoVertical.svg";
import submersivel from "../../Assets/Icons/submersivel.svg";
import {
  GraficoBomba,
  GraficoPoco,
  ModalGraficoBomba,
  ModalGraficoPoco,
} from "./Graficos";
import { ElevatoriaContext } from "../../Context/contextElevatoria";
import {
  ModalRelatorioBombaStyled,
  ModalRelatoriosStyled,
  ModalsConfirmeStyled,
} from "../../Styles/Modals";
import { Bounce, toast } from "react-toastify";
import { IoClose, IoMoon } from "react-icons/io5";
import {
  IoIosArrowForward,
  IoIosArrowBack,
  IoMdCloseCircleOutline,
} from "react-icons/io";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { formatInTimeZone } from "date-fns-tz";
import {
  AiOutlineAlert,
  AiTwotoneAlert,
  AiFillAlert,
  AiTwotoneQuestionCircle,
} from "react-icons/ai";
import { TbArrowBackUp, TbReport } from "react-icons/tb";
import { BsArrowCounterclockwise } from "react-icons/bs";
import { format } from "date-fns";
import { SquareLoading } from "../../components/loaders";
import DatePicker from "react-datepicker";
import { FaSun } from "react-icons/fa";

export const Elevatorias = () => {
  const { codigo_estacao } = useParams();
  const {
    headerApi,
    infoUser,
    socket,
    userOn,
    navigate,
    darkMode,
    setDarkMode,
  } = useContext(HomeContext);
  const {
    setDadosControle,
    modalConfirmaBomba,
    setModalConfirmaBomba,
    modalIsOpen,
    modalIsOpenBomba,
    eventos,
    listarEventos,
    modalEventosFalhas,
    setModalEventosFalhas,
    modalConfirmaControler,
    setModalConfirmaControler,
    modalAvisosEmegencia,
    setModalAvisosEmegencia,
    modalReladorioBombaOn,
    setModalRelatorioBombaOn,
    selectedDate,
    selectedDateBomba,
    reversoOn,
    setReversoOn,
    ligarReversoModal,
    ligarSetReversoModal,
    setModalIsOpen,
    setIdDataPoco,
    loading,
    setLoading,
    modalRelatoriosOn,
    setModalRelatoriosOn,
  } = useContext(ElevatoriaContext);

  const formatDate = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "dd/MM/yyyy");
  };

  const formatTime = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "HH:mm");
  };

  const [elevatorias, setElevatorias] = useState({});
  const [mostraBomba, setMostraBomba] = useState([]);
  const [setListControlerBomba] = useState([]);
  const [ModalModControler, setModalModControler] = useState([]);
  const [idEstacao, setIdEstacao] = useState(null);
  const [statusPoco, setStatusPoco] = useState([]);
  const [alerEmergenciaList, setAlerEmergenciaList] = useState([]);
  const [bombaIdSelected, setBombaIdSelected] = useState(null);
  const [acionamentoSave, setAcionamentoSave] = useState([]);
  const [idBombaReverso, setIdBombaReverso] = useState(null);
  const [statusBombaReverso, setStatusBombaReverso] = useState(null);

  const timeEspera = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };

  const aoListarIdEstacao = async () => {
    try {
      const listarEstacao = await apiSae.get(`estacao/leituratodos`, headerApi);
      const idEstacao = listarEstacao.data.find(
        (e) => codigo_estacao === e.codigo
      );
      if (!idEstacao) {
        navigate("/");
        return;
      }
      setIdEstacao(idEstacao.id);
      return idEstacao.id;
    } catch (error) {
      console.log(error);
    }
  };

  const aoListarElevatoria = async () => {
    try {
      let idEstacaoSalve = null;
      idEstacaoSalve = idEstacao;
      if (!idEstacaoSalve) {
        idEstacaoSalve = await aoListarIdEstacao();
      }

      if (!idEstacaoSalve) {
        return;
      }

      const Response = await apiSae.get(
        `estacao/leitura/${idEstacaoSalve}`,
        headerApi
      );
      setElevatorias(Response.data);
      listarEventos(Response.data.id);
      // ListAlerts(idEstacaoSalve);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const aoListarControlersBombas = async () => {
    try {
      const response = await apiSae.get(
        "bomba/controle/LeituraTodos",
        headerApi
      );
      setListControlerBomba(response.data);
    } catch (error) {}
  };

  const calcularPorcentagem = (valorAtual, valorMaximo) => {
    return (valorAtual / valorMaximo) * 100;
  };

  const expandirBomba = (itemId) => {
    setMostraBomba((prevExpandedItems) =>
      prevExpandedItems.includes(itemId)
        ? prevExpandedItems.filter((id) => id !== itemId)
        : [...prevExpandedItems, itemId]
    );
  };

  const aoControlarBomba = async (idBomba) => {
    setDadosControle(idBomba);
    setModalConfirmaBomba(true);
  };

  const verifStatusGtwPoco = async (idGTw) => {
    try {
      if (idGTw != null) {
        const status = await apiSae.get(`/users/gtw/${idGTw}`, headerApi);
        return status.data.online;
      }
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    setLoading(true);
    aoListarElevatoria();
    aoListarControlersBombas();
    ListAlerts(idEstacao);
  }, []);

  useEffect(() => {
    // update_ControlerBomba
    if (socket) {
      socket.on("update_elevatoria", () => {
        aoListarElevatoria();
      });
      socket.on("update_Bomba", () => {
        aoListarElevatoria();
      });
      socket.on("creat_alerta", () => {
        aoListarElevatoria();
      });
      socket.on("update_ControlerBomba", () => {
        aoListarControlersBombas();
        aoListarElevatoria();
      });
      socket.on("update_avisoEmergencia", () => {
        ListAlerts(idEstacao);
      });
    }
  }, [socket]);

  const fetchStatuses = async () => {
    await timeEspera(100);

    try {
      const newStatuses = {};
      let idEstcaoSalve = idEstacao;
      if (!elevatorias.pocos) {
        if (idEstcaoSalve) {
          const Response = await apiSae.get(
            `estacao/leitura/${idEstcaoSalve}`,
            headerApi
          );
          if (
            Response.data.hasOwnProperty("pocos") &&
            Response.status === 200
          ) {
            for (const poco of Response.data.pocos || []) {
              newStatuses[poco.id] = await verifStatusGtwPoco(poco.gtw_poco);
            }
          }
        } else {
          const idEstacao = await aoListarIdEstacao();
          const Response = await apiSae.get(
            `estacao/leitura/${idEstacao}`,
            headerApi
          );
          if (
            Response.data.hasOwnProperty("pocos") &&
            Response.status === 200
          ) {
            for (const poco of Response.data.pocos || []) {
              newStatuses[poco.id] = await verifStatusGtwPoco(poco.gtw_poco);
            }
          }
        }
      } else {
        for (const poco of elevatorias.pocos || []) {
          newStatuses[poco.id] = await verifStatusGtwPoco(poco.gtw_poco);
        }
      }
      setStatusPoco(newStatuses);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, [userOn]); // Executa quando `elevatorias.pocos` mudar

  useEffect(() => {
    if (Object.keys(elevatorias).length > 0) {
      setLoading(false);
    }
  }, [elevatorias]);

  const ListAlerts = async (idSaveFuncao) => {
    try {
      if (idSaveFuncao === null) {
        idSaveFuncao = await aoListarIdEstacao();
      }
      const AlertaList = await apiSae.get(
        `/avisoEmergencia/listEstacao/${idSaveFuncao}`,
        headerApi
      );
      setAlerEmergenciaList(AlertaList.data);
    } catch (error) {
      console.log(error);
    }
  };

  const eventosList = eventos.results;

  const ultimosEventos = eventosList.slice(0, 10);

  useEffect(() => {
    if (
      modalRelatoriosOn ||
      modalEventosFalhas ||
      modalAvisosEmegencia ||
      modalConfirmaControler ||
      modalReladorioBombaOn
    ) {
      document.body.classList.add("modal-open"); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove("modal-open"); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [
    modalEventosFalhas,
    modalAvisosEmegencia,
    modalConfirmaControler,
    modalReladorioBombaOn,
    modalRelatoriosOn,
  ]);

  return (
    <ElevatoriaStyled darkmode={darkMode}>
      {loading && <SquareLoading />}
      <Header pgAdmin={true} />
      <HeaderMobil pgAdmin={true} />
      {reversoOn && (
        <ModalAtivacteRevese
          idBomba={idBombaReverso}
          status={statusBombaReverso}
        />
      )}
      {ligarReversoModal && <ModalRodarRevese salveInf={acionamentoSave} />}
      {modalAvisosEmegencia && <ModalAvisoEmergencia idEstcao={idEstacao} />}
      {modalConfirmaBomba && <ModalsConfirmaAcao salveInf={acionamentoSave} />}
      {modalIsOpen && <ModalGraficoPoco />}
      {modalIsOpenBomba && <ModalGraficoBomba />}
      {modalEventosFalhas && <ModalsEventoFalha idEstacao={idEstacao} />}
      {modalRelatoriosOn && <ModalRelatorios elevatoria={elevatorias} />}
      {modalConfirmaControler && (
        <ModalsConfirmaAcaoControler
          idPoco={ModalModControler[0]}
          statusButton={ModalModControler[1]}
          idEstacao={idEstacao}
        />
      )}
      {modalReladorioBombaOn && (
        <Modalrelatorio bombaId={bombaIdSelected} data={selectedDateBomba} />
      )}
      <LogoBG />
      <div className="IconAlerte">
        <button onClick={() => setModalAvisosEmegencia(true)}>
          {alerEmergenciaList.length > 0 ? (
            alerEmergenciaList.some(
              (alerta) => alerta.status === "pendente"
            ) ? (
              <AiFillAlert className="iconStyledAlertEmegencia" />
            ) : (
              <AiTwotoneAlert className="iconStyledAlertPorcesso" />
            )
          ) : (
            <AiOutlineAlert className="iconStyledAlert" />
          )}
        </button>
        <div
          className="darkmode"
          onClick={() => {
            localStorage.setItem("SaeDarkMode", !darkMode);
            setDarkMode(!darkMode);
          }}
        >
          <FaSun className="iconMode icone01" />
          <IoMoon className="iconMode icone02" />
          <span></span>
        </div>
      </div>

      <ul className="elevatoriasUl">
        {elevatorias.pocos &&
          elevatorias.pocos.map((poco, index) => {
            const alturaMax = calcularPorcentagem(
              poco.nivel_atual,
              poco.altura_poco
            );

            const alturaMin = calcularPorcentagem(
              poco.nivel_minimo,
              poco.altura_poco
            );

            const alturaLigaB1 = calcularPorcentagem(
              poco.bombas[0]?.nivel_acionamento,
              poco.altura_poco
            );

            const alturaDesligaB1 = calcularPorcentagem(
              poco.bombas[0]?.nivel_desligamento,
              poco.altura_poco
            );

            let alturaLigaB2;
            let alturaDesligaB2;

            if (poco.bombas[1]) {
              alturaLigaB2 = calcularPorcentagem(
                poco.bombas[1]?.nivel_acionamento,
                poco.altura_poco
              );

              alturaDesligaB2 = calcularPorcentagem(
                poco.bombas[1]?.nivel_desligamento,
                poco.altura_poco
              );
            }
            let alturaLigaB3;
            let alturaDesligaB3;

            if (poco.bombas[2]) {
              alturaLigaB3 = calcularPorcentagem(
                poco.bombas[2]?.nivel_acionamento,
                poco.altura_poco
              );

              alturaDesligaB3 = calcularPorcentagem(
                poco.bombas[2]?.nivel_desligamento,
                poco.altura_poco
              );
            }

            const alturaAltual = calcularPorcentagem(
              poco.nivel_atual,
              poco.altura_poco
            );

            const BombasOrdernada = poco.bombas.sort((a, b) => a.id - b.id);
            const pocoIncluso = mostraBomba.includes(poco.id);

            let StatusPocoOn = false;

            StatusPocoOn = statusPoco[poco.id];

            return (
              <li key={poco.id} className="liElevatoria">
                <div className="tituloPoco">
                  <div className="iconBack" onClick={() => navigate(-1)}>
                    <TbArrowBackUp />
                  </div>
                  <div className="tituloStatus">
                    <h3>{elevatorias.nome_estacao}:</h3>
                    {elevatorias.pocos.length > 1 && (
                      <h2 className="numeroPoco">Poço {index + 1}</h2>
                    )}
                    <div className={`statusPoco`}>
                      <span
                        className={`statusDisplay ${
                          StatusPocoOn == true ? "StatusOn" : "StatusOFF"
                        }`}
                      />
                      {StatusPocoOn == true ? <p>Online</p> : <p>Offline</p>}
                    </div>
                  </div>
                </div>
                <section className="sectionMain">
                  <div className="blocoPocoTabela">
                    <div className="pocoStatusConteiner">
                      <div className="pocoStatus">
                        <div className="blocoPoco">
                          <Nivel
                            infoPoco={"Extravasor"}
                            nivelPoco={calcularPorcentagem(
                              poco.altura_util_poco,
                              poco.altura_poco
                            )}
                          />
                          <Nivel
                            infoPoco={"Nível Máximo"}
                            nivelPoco={calcularPorcentagem(
                              poco.nivel_maximo,
                              poco.altura_poco
                            )}
                          />
                          {alturaLigaB2 !== 0 && poco.bombas[1] && (
                            <Nivel
                              infoPoco={"Liga B. 2"}
                              nivelPoco={alturaLigaB2}
                            />
                          )}
                          {alturaLigaB2 !== 0 && poco.bombas[1] && (
                            <Nivel
                              infoPoco={"Desliga B. 2"}
                              nivelPoco={alturaDesligaB2}
                            />
                          )}

                          {/* {poco.bombas[2] && (
                        <Nivel
                          infoPoco={"Liga B. 3"}
                          nivelPoco={alturaLigaB3}
                        />
                      )} */}
                          {/* {poco.bombas[2] && (
                        <Nivel
                          infoPoco={"Desliga B. 3"}
                          nivelPoco={alturaDesligaB3}
                        />
                      )} */}
                          <Nivel
                            infoPoco={`Liga B${alturaLigaB2 == 0 ? "" : ".1"}`}
                            nivelPoco={alturaLigaB1}
                          />
                          <Nivel
                            infoPoco={`Desliga B${
                              alturaLigaB2 == 0 ? "" : ".1"
                            } `}
                            nivelPoco={alturaDesligaB1}
                          />
                          <Nivel
                            infoPoco={"Nível Mínimo"}
                            nivelPoco={alturaMin}
                          />
                          <Poco alturaAtual={alturaAltual} />
                        </div>
                        <div className="infoAltura">
                          <div className="divInfo">
                            <div className="info">{poco.altura_poco} m</div>
                            <p>Altura do Poço</p>
                          </div>
                          <div className="divInfo">
                            <div className="info">
                              {poco.altura_util_poco} m
                            </div>
                            <p>Altura Útil do Poço</p>
                          </div>
                          <div className="ControlerInf">
                            <p>Controle</p>

                            <BotaoOnOff
                              valor={poco.automatico === 2}
                              disabled={
                                infoUser.role === "1" ||
                                poco.automatico === 0 ||
                                !StatusPocoOn
                              }
                              onClick={() => {
                                setModalModControler([
                                  poco.id,
                                  poco.automatico,
                                ]);
                                setModalConfirmaControler(true);
                              }}
                            >
                              <Switch valor={poco.automatico === 2}></Switch>
                              <span className="status">
                                {poco.automatico === 1 ? "AUT" : "RMT"}
                              </span>
                            </BotaoOnOff>
                            <span className="infoButton">AUTO / REMOTO</span>
                          </div>
                        </div>
                      </div>
                      <div className="BlocoInfoPoco">
                        <h3>{elevatorias.nome_estacao}</h3>
                        <div className="dadosPoco">
                          <div className="dadosInfoPoco">
                            <p>Altura Atual do Poço</p>
                            <div className="cxInfoPoco">
                              {Math.floor(alturaMax)}%
                            </div>
                          </div>
                          <div className="dadosInfoPoco">
                            <p>
                              Nível de Acionamento <br /> Bomba I
                            </p>
                            <div className="cxInfoPoco">
                              {poco.bombas[0]?.nivel_acionamento} m
                            </div>
                          </div>

                          <div className="dadosInfoPoco">
                            {poco.bombas[1] && (
                              <>
                                <p>
                                  Nível de Acionamento <br />
                                  Bomba II
                                </p>

                                <div className="cxInfoPoco">
                                  {poco.bombas[1]?.nivel_acionamento} m
                                </div>
                              </>
                            )}
                          </div>
                          <div className="dadosInfoPoco">
                            {/* {poco.bombas[2] && (
                            <>
                              <p>
                                Nível de Acionamento <br />
                                Bomba III
                              </p>
                              <div className="cxInfoPoco">
                                {poco.bombas[2]?.nivel_acionamento} m
                              </div>
                            </>
                          )} */}
                          </div>
                        </div>
                        <div className="blocoControle">
                          <div className="controle">
                            <h3>Modo de Controle</h3>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 1
                                    ? "var(--cor-infor)"
                                    : darkMode
                                    ? "var(--cor-cinza)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Auto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 2
                                    ? "var(--cor-infor)"
                                    : darkMode
                                    ? "var(--cor-cinza)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Remoto</p>
                            </div>
                            <div className="divControler">
                              <CxControle
                                activo={
                                  poco.automatico == 0
                                    ? "var(--cor-infor)"
                                    : darkMode
                                    ? "var(--cor-cinza)"
                                    : darkMode
                                    ? "var(--cor-cinza)"
                                    : "var(--branco)"
                                }
                              ></CxControle>
                              <p>Manual</p>
                            </div>
                          </div>
                        </div>
                        <div className="blocoControle">
                          <div className="controle">
                            <h3>Gerador</h3>
                            <CxControle
                              activo={
                                elevatorias.geradores[0] &&
                                elevatorias.geradores[0].status
                                  ? "var(--cor-infor)"
                                  : darkMode
                                  ? "var(--cor-cinza)"
                                  : "var(--branco)"
                              }
                            ></CxControle>
                            <p>Ligado</p>
                            <CxControle
                              activo={
                                elevatorias.geradores[0] &&
                                !elevatorias.geradores[0].status
                                  ? "var(--cor-infor)"
                                  : darkMode
                                  ? "var(--cor-cinza)"
                                  : "var(--branco)"
                              }
                            ></CxControle>
                            <p>Desligado</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="blocoTabelaGrafico">
                      <div className="blocoTabelaConteiner">
                        <div className="blocoTabela">
                          <div className="tabela">
                            <table>
                              <thead>
                                <tr>
                                  <th>Usuário</th>
                                  <th>Data</th>
                                  <th>Hora</th>
                                  <th>Evento</th>
                                </tr>
                              </thead>
                              <tbody>
                                {ultimosEventos.map((evento) => {
                                  return (
                                    <tr key={evento.id}>
                                      <td>
                                        {evento.usuario.gateway
                                          ? "Localmente"
                                          : evento.usuario.nome}
                                      </td>
                                      <td>{formatDate(evento.createdAt)}</td>
                                      <td>{formatTime(evento.createdAt)}</td>
                                      <td className="mensagemTr">
                                        {evento.mensagem}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="botaoTabela">
                          <button
                            onClick={() => {
                              setModalEventosFalhas(true);
                            }}
                          >
                            Abrir Eventos
                          </button>
                          <button
                            onClick={() => {
                              setModalRelatoriosOn(true);
                              setIdDataPoco(poco.id);
                            }}
                          >
                            Relatórios
                          </button>
                        </div>
                      </div>
                      <GraficoPoco
                        idPoco={poco.id}
                        altura={poco.altura_util_poco}
                      />
                    </div>
                  </div>

                  <div className="botaoBombas">
                    <button onClick={() => expandirBomba(poco.id)}>
                      Bombas
                      {pocoIncluso ? (
                        <IoIosArrowUp className="icone" />
                      ) : (
                        <IoIosArrowDown className="icone" />
                      )}
                    </button>
                  </div>
                </section>
                {pocoIncluso && (
                  <section className={`bombasSection`}>
                    <ul className="ulBomba">
                      {BombasOrdernada &&
                        BombasOrdernada.map((bomba, index) => {
                          return (
                            <BombasStyled key={bomba.id} darkmode={darkMode}>
                              <div className="tituloBombas">
                                <h2>BOMBA - {index + 1}</h2>
                                <img
                                  src={
                                    bomba.tipo_bomba === "helicoidal"
                                      ? helicoidal
                                      : bomba.tipo_bomba === "submersivel"
                                      ? submersivel
                                      : vertical
                                  }
                                  alt=""
                                />
                                <ul className="statusBomba">
                                  <li>
                                    <StatusBomba
                                      status={
                                        bomba.status === 1
                                          ? "var(--ligado)"
                                          : "transparent"
                                      }
                                    />
                                    <p>Ligado</p>
                                  </li>
                                  <li>
                                    <StatusBomba
                                      status={
                                        bomba.status === 0
                                          ? "var(--desligado)"
                                          : "transparent"
                                      }
                                    />
                                    <p>Desligado</p>
                                  </li>
                                  <li>
                                    <StatusBomba
                                      className={
                                        bomba.status === 2 ? "blink" : ""
                                      }
                                      status={
                                        bomba.status === 2
                                          ? "var(--alerta)"
                                          : "transparent"
                                      }
                                    />
                                    <p>Falha</p>
                                  </li>
                                </ul>
                              </div>
                              <div className="conteinerInforBombas">
                                <div
                                  className="RelatorioInfoBombas"
                                  onClick={() => {
                                    setBombaIdSelected(bomba.id);
                                    setModalRelatorioBombaOn(true);
                                  }}
                                >
                                  <TbReport />
                                </div>
                                <div className="blocoInfoBombas">
                                  <ul>
                                    <li>
                                      <p className="infoTexto">Tensão:</p>{" "}
                                      <div className="cxInfoBombas">
                                        {bomba.status === 0
                                          ? "0.00"
                                          : (
                                              (bomba.tensaoR +
                                                bomba.tensaoS +
                                                bomba.tensaoT) /
                                                3 +
                                              160
                                            ).toFixed(2)}{" "}
                                        V
                                      </div>
                                    </li>
                                    <li>
                                      <p className="infoTexto">Corrente:</p>{" "}
                                      <div className="cxInfoBombas">
                                        {bomba.status === 0
                                          ? "0"
                                          : bomba.corrente.toFixed(2)}{" "}
                                        A
                                      </div>
                                    </li>
                                    <li>
                                      <p className="infoTexto">Rotação:</p>{" "}
                                      <div className="cxInfoBombas">
                                        {bomba.status === 0
                                          ? "0"
                                          : bomba.rpm.toFixed(0)}
                                        RPM
                                      </div>
                                    </li>
                                    <li>
                                      <p className="infoTexto">Horimetro:</p>{" "}
                                      <div className="cxInfoBombas">
                                        {bomba.horimetro} Hrs
                                      </div>
                                    </li>
                                    <li>
                                      <p className="infoTexto">Frequencia:</p>{" "}
                                      <div className="cxInfoBombas">
                                        {bomba.status === 0
                                          ? "0"
                                          : bomba.frequencia.toFixed(0)}{" "}
                                        Hz
                                      </div>
                                    </li>
                                  </ul>
                                  <div
                                    className={`switchButton ${
                                      infoUser.role === "1"
                                        ? "switchButtonOff"
                                        : ""
                                    }`}
                                  >
                                    <BotaoOnOff
                                      valor={bomba.status === 1}
                                      onClick={() => {
                                        if (bomba.reverso) {
                                          ligarSetReversoModal(true);
                                          setAcionamentoSave([
                                            bomba.id,
                                            idEstacao,
                                            bomba.status,
                                          ]);
                                        } else {
                                          setAcionamentoSave([
                                            bomba.id,
                                            idEstacao,
                                            bomba.status,
                                          ]);
                                          aoControlarBomba(
                                            bomba.bombaControler[0].id
                                          );
                                        }
                                      }}
                                      disabled={
                                        infoUser.role === "1" ||
                                        bomba.bombaControler[0].comando ||
                                        poco.automatico !== 2 ||
                                        !StatusPocoOn
                                      }
                                    >
                                      <Switch valor={bomba.status === 1}>
                                        {bomba.bombaControler[0].comando && (
                                          <FaArrowRotateLeft className="carregar" />
                                        )}
                                      </Switch>
                                      <span className="status">
                                        {bomba.status === 1 ? "On" : "Off"}
                                      </span>
                                    </BotaoOnOff>

                                    <div className={`buttonReveso`}>
                                      <span>Rodar Reverso</span>
                                      <div
                                        className={`iconReverso ${
                                          bomba.reverso && "iconReversoOn"
                                        }`}
                                        onClick={() => {
                                          setIdBombaReverso(bomba.id);
                                          setStatusBombaReverso(bomba.reverso);
                                          setReversoOn(!reversoOn);
                                        }}
                                      >
                                        <BsArrowCounterclockwise />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <GraficoBomba idBomba={bomba.id} />
                                </div>
                              </div>
                            </BombasStyled>
                          );
                        })}
                    </ul>
                  </section>
                )}
              </li>
            );
          })}
        <br />
      </ul>
      <Footer background={true} relative={false} />
    </ElevatoriaStyled>
  );
};

export const ModalsConfirmaAcao = ({ salveInf }) => {
  const { headerApi, infoUser } = useContext(HomeContext);
  const {
    dadosControle,
    setModalConfirmaBomba,
    modalConfirmaBomba,
    idBombasLoading,
    setidBombasLoading,
  } = useContext(ElevatoriaContext);

  const carregaAnimacao = (itemId) => {
    setidBombasLoading((prevExpandedItems) =>
      prevExpandedItems.includes(itemId)
        ? prevExpandedItems.filter((id) => id !== itemId)
        : [...prevExpandedItems, itemId]
    );
  };

  const aoContolarBomba = async () => {
    const acionamento = { comando: true };

    try {
      const enviaDadosControle = await apiSae.patch(
        `bomba/controle/${dadosControle}`,
        acionamento,
        headerApi
      );

      const alertaEvent = {
        mensagem:
          salveInf[2] == 1
            ? "Comando de desligamento da bomba enviado remotamente!"
            : "Comando de acionamento da bomba enviado remotamente!",
        bomba: salveInf[0],
        estacao: salveInf[1],
      };

      const alertEvent = await apiSae.post(`alertas`, alertaEvent, headerApi);
    } catch (error) {
      console.log(error);
      toast.error(`${error.response.data.message}`, {
        position: "top-right",
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setModalConfirmaBomba(!modalConfirmaBomba);
    }
  };

  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>Tem certeza que deseja executar esta ação?</h3>
        <div className="botao">
          <button onClick={() => aoContolarBomba()}>Sim</button>
          <button
            className="botaoNao"
            onClick={() => {
              setModalConfirmaBomba(!modalConfirmaBomba);
            }}
          >
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};

export const ModalsConfirmaAcaoControler = ({
  idPoco,
  statusButton,
  idEstacao,
}) => {
  const { modalConfirmaControler, setModalConfirmaControler } =
    useContext(ElevatoriaContext);
  const { headerApi } = useContext(HomeContext);

  const UpdateContrePoco = async () => {
    const statusJson = {
      automatico: 1,
    };

    if (statusButton === 1) {
      statusJson.automatico = 2;
    }
    try {
      const enviaDadosControle = await apiSae.patch(
        `/poco/${idPoco}`,
        statusJson,
        headerApi
      );

      const alertaEvent = {
        mensagem:
          statusButton == 1
            ? "O painel foi alterado para o modo Remoto"
            : "O painel foi alterado para o modo Automático",
        estacao: idEstacao,
        poco: idPoco,
      };

      const alertEvent = await apiSae.post(`alertas`, alertaEvent, headerApi);
    } catch (error) {
      console.log(error);
      toast.error(`${error.response.data.message}`, {
        position: "top-right",
        autoClose: 3500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setModalConfirmaControler(!modalConfirmaControler);
    }
  };

  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>Tem certeza que deseja mudar modo de Controle?</h3>
        <div className="botao">
          <button onClick={() => UpdateContrePoco()}>Sim</button>
          <button
            className="botaoNao"
            onClick={() => setModalConfirmaControler(false)}
          >
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};

export const ModalsEventoFalha = ({ idEstacao }) => {
  const {
    modalEventosFalhas,
    setModalEventosFalhas,
    eventos,
    setEventos,
    listarEventos,
  } = useContext(ElevatoriaContext);
  const [showModalOptions, setShowModalOptions] = useState(false);
  const [filteredEventos, setFilteredEventos] = useState(eventos);
  const [pageNumber, setPageNumber] = useState(1);
  const [listAlerta, setListAlerta] = useState([]);

  const formatDate = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "dd/MM/yyyy");
  };

  const formatTime = (timestamp) => {
    const timeZone = "America/Sao_Paulo"; // Fuso horário do Brasil

    // Formata o timestamp no fuso horário especificado
    return formatInTimeZone(timestamp, timeZone, "HH:mm");
  };

  const filterEventos = (dataInicio, dataFim) => {
    const filtered = eventos.results.filter((evento) => {
      const eventoDate = new Date(parseInt(evento.createdAt, 10));

      return (
        eventoDate >= new Date(dataInicio) && eventoDate <= new Date(dataFim)
      );
    });

    setFilteredEventos({ results: filtered });
  };

  const listAlertas = async () => {
    const token = localStorage.getItem("tokenBrk");
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await apiSae.get(
        `/alertas/list/${idEstacao}`,
        headerApi
      );
      setListAlerta(response.data);
      return response.data;
    } catch (error) {}
  };

  const handleConfirm = async ({ dataInicio, dataFim, formato }) => {
    let eventosParaExportar = filteredEventos.results;
    const timeZone = "America/Sao_Paulo";

    let filterListerAlerta = listAlerta;

    if (dataInicio && dataFim) {
      filterEventos(dataInicio, dataFim);

      filterListerAlerta = listAlerta.filter((e) => {
        const alertDate = formatInTimeZone(e.createdAt, timeZone, "yyyy-MM-dd");
        return alertDate >= dataInicio && alertDate <= dataFim;
      });

      setListAlerta(filterListerAlerta);
    } else {
      setFilteredEventos({ results: eventos.results || [] }); // Se não houver data, mostra todos os eventos
    }
    if (formato === "pdf") {
      setListAlerta(filterListerAlerta);
      setTimeout(() => {
        exportToPDF(filterListerAlerta);
      }, 500);
    } else {
      exportToCSV(filterListerAlerta);
    }
  };

  const exportToPDF = async (dataList) => {
    const doc = new jsPDF();
    const tableColumn = ["Data", "Hora", "Evento / Falha", "lido"];

    // await listAlertas();

    const tableRows = dataList.map((evento) => [
      formatDate(evento.createdAt),
      formatTime(evento.createdAt),
      evento.mensagem,
      evento.lido ? "Sim" : "Não",
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: "auto" },
      },
      theme: "grid",
    });

    doc.save(`Eventos_Falhas_${new Date().toLocaleDateString()}.pdf`);

    await listarEventos(idEstacao); // Aguarde listarEventos ser concluído
    setFilteredEventos(eventos); // Atualiza o estado com todos os eventos
    setPageNumber(1); // Reseta a página
  };

  const exportToCSV = async (dataList) => {
    const headers = "Data,Hora,Evento / Falha,lido\n";
    const csvRows = dataList;
    const exportToCSV = async () => {
      if (
        !filteredEventos ||
        !filteredEventos.results ||
        filteredEventos.results.length === 0
      ) {
        console.error("Nenhum dado disponível para exportar.");
        return;
      }

      const headers = "Data,Hora,Evento / Falha,lido\n";
      const csvRows = filteredEventos.results
        .map(
          (evento) =>
            `${formatDate(evento.createdAt)},${formatTime(evento.createdAt)},${
              evento.mensagem
            },${evento.lido}`
        )
        .join("\n");

      const csvString = headers + csvRows;
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Eventos_Falhas_${new Date().toLocaleDateString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      await listarEventos(idEstacao); // Aguarde listarEventos ser concluído
      setFilteredEventos(eventos); // Atualiza o estado com todos os eventos
      setPageNumber(1); // Reseta a página
    };
  };

  const alterPage = async (url) => {
    const token = localStorage.getItem("tokenBrk");
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await apiSae.get(
        `/alertas/leitura/${idEstacao}${url}`,
        headerApi
      );
      setFilteredEventos(response.data || { result: [] });
    } catch (error) {}
  };

  const handleCheckboxChange = async (evento) => {
    const token = localStorage.getItem("tokenBrk");
    const headerApi = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      // Atualiza o evento para marcado como lido
      await apiSae.patch(
        `/alertas/${evento.id}`,
        { lido: !evento.lido },
        headerApi
      );

      // Atualiza o estado local
      setFilteredEventos((prevEventos) => ({
        ...prevEventos,
        results: prevEventos.results.map((e) =>
          e.id === evento.id ? { ...e, lido: !e.lido } : e
        ),
      }));
    } catch (error) {
      console.error("Erro ao atualizar evento:", error);
    }
  };

  useEffect(() => {
    listAlertas();
  }, []);

  return (
    <>
      {modalEventosFalhas && (
        <EventosFalhasStyled>
          <div className="container">
            <div className="cabecalho">
              <h3>Tabela de Eventos</h3>

              <span
                className="fechaModal"
                onClick={() => setModalEventosFalhas(false)}
              >
                <IoClose />
              </span>
            </div>
            <div className="tabelaGeral">
              <div className="tabela">
                <table>
                  <thead>
                    <tr>
                      <th>Usuário</th>
                      <th>Data</th>
                      <th>Hora</th>
                      <th>Evento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(filteredEventos.results || []).map((evento) => (
                      <tr key={evento.id}>
                        <td>
                          {evento.usuario.gateway
                            ? "Localmente"
                            : evento.usuario.nome}
                        </td>
                        <td>{formatDate(evento.createdAt)}</td>
                        <td>{formatTime(evento.createdAt)}</td>
                        <td>{evento.mensagem}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="setasPaginacao">
              <button
                className={filteredEventos.previous === null && "disable"}
                disabled={filteredEventos.previous === null}
                onClick={() => {
                  setPageNumber(pageNumber - 1);
                  alterPage(filteredEventos.previous);
                }}
              >
                <IoIosArrowBack />
              </button>
              <section>{pageNumber}</section>
              <button
                className={filteredEventos.next === null && "disable"}
                disabled={filteredEventos.next === null}
                onClick={() => {
                  setPageNumber(pageNumber + 1);
                  alterPage(filteredEventos.next);
                }}
              >
                <IoIosArrowForward />
              </button>
            </div>
            <button
              className="botaoEventos"
              onClick={() => setShowModalOptions(true)}
            >
              Download
            </button>
          </div>
        </EventosFalhasStyled>
      )}
      {showModalOptions && (
        <ModalSelecaoPeriodo
          onConfirm={handleConfirm}
          onCancel={() => setShowModalOptions(false)}
        />
      )}
    </>
  );
};

export const ModalSelecaoPeriodo = ({ onConfirm, onCancel }) => {
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [formato, setFormato] = useState("pdf");

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    document.querySelector("#dataInicio").setAttribute("max", today);
    document.querySelector("#dataFim").setAttribute("max", today);
  }, []);

  const handleConfirm = () => {
    onConfirm({ dataInicio, dataFim, formato });
    onCancel();
  };

  return (
    <EventosFalhasStyled>
      <div className="modal-options">
        <div className="modal-content">
          <h4>Selecionar Período e Formato</h4>
          <div className="form-group">
            <label>Data Início</label>
            <input
              id="dataInicio"
              type="date"
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
              max={new Date().toISOString().split("T")[0]} // Define a data máxima
              required={true}
            />
          </div>
          <div className="form-group">
            <label>Data Fim</label>
            <input
              id="dataFim"
              type="date"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
              max={new Date().toISOString().split("T")[0]} // Define a data máxima
              required={true}
            />
          </div>
          <div className="form-group">
            <label>Formato</label>
            <select
              value={formato}
              onChange={(e) => setFormato(e.target.value)}
            >
              <option value="pdf">PDF</option>
              <option value="csv">CSV</option>
            </select>
          </div>
          <div className="buttons">
            <button onClick={handleConfirm}>Confirmar</button>
            <button onClick={onCancel}>Cancelar</button>
          </div>
        </div>
      </div>
    </EventosFalhasStyled>
  );
};

export const ModalAvisoEmergencia = ({ idEstcao }) => {
  const { setModalAvisosEmegencia } = useContext(ElevatoriaContext);
  const { headerApi, infoUser, socket, userOn } = useContext(HomeContext);

  const [sectionSelect, setSectionSelect] = useState(true);
  const [alerEmergenciaList, setAlerEmergenciaList] = useState([]);
  const [alerEmergenciaListHistorico, setAlerEmergenciaListHistorico] =
    useState([]);

  const listHistorico = async () => {
    try {
      const response = await apiSae.get(
        `avisoEmergencia/listHistoricoEstacao/${idEstcao}`,
        headerApi
      );
      setAlerEmergenciaListHistorico(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const listAlerts = async () => {
    try {
      const response = await apiSae.get(
        `avisoEmergencia/listEstacao/${idEstcao}`,
        headerApi
      );
      setAlerEmergenciaList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const UpdateAlerta = async (statusAlert, idAlert) => {
    const status = {
      status: statusAlert,
    };
    try {
      const update = await apiSae.patch(
        `avisoEmergencia/${idAlert}`,
        status,
        headerApi
      );

      listAlerts();
    } catch (error) {}
  };

  useEffect(() => {
    let interval;

    if (sectionSelect) {
      listAlerts(); // Chama imediatamente ao ativar a seção

      interval = setInterval(() => {
        listAlerts();
      }, 60000); // Executa a cada 60 segundos (1 minuto)
    }

    return () => {
      clearInterval(interval); // Limpa o intervalo ao sair da seção
    };
  }, [sectionSelect]); // Dispara sempre que sectionSelect mudar

  useEffect(() => {
    if (socket) {
      socket.on("update_avisoEmergencia", () => {
        listAlerts();
      });
    }
  }, [socket]);

  return (
    <ModalStyledAvisoEmergencia>
      <div className="conteiner">
        <span
          className="Closemodal"
          onClick={() => setModalAvisosEmegencia(false)}
        >
          <IoClose />
        </span>

        <div className="SelectSections">
          <h2
            className={`${sectionSelect && "sectionAtive"}`}
            onClick={() => {
              setSectionSelect(true);
              listAlerts();
            }}
          >
            Alertas
          </h2>
          <h2
            className={`${!sectionSelect && "sectionAtive"}`}
            onClick={() => {
              setSectionSelect(false);
              listHistorico();
            }}
          >
            Histórico de Alertas
          </h2>
        </div>

        {sectionSelect ? (
          <section>
            {alerEmergenciaList.length > 0 ? (
              <ul className="ulHistorico">
                {alerEmergenciaList.map((alerta) => {
                  const dataErro = new Date(alerta.createdAt);
                  const agora = new Date();
                  const diffMs = agora - dataErro; // Diferença em milissegundos
                  const diffMin = Math.floor(diffMs / 60000); // Converter para minutos
                  const diffHoras = Math.floor(diffMin / 60);
                  const diffDias = Math.floor(diffHoras / 24);

                  let tempoDecorrido = "";
                  if (diffDias > 0) {
                    tempoDecorrido = `${diffDias} dia(s)`;
                  } else if (diffHoras > 0) {
                    tempoDecorrido = `${diffHoras} hora(s)`;
                  } else {
                    tempoDecorrido = `${diffMin} minuto(s)`;
                  }
                  return (
                    <li
                      className={`${
                        alerta.status === "pendente" ? "pedente" : "manuteçao"
                      }`}
                    >
                      <span className="iconStyled">
                        <AiOutlineAlert />
                      </span>
                      <div className="Status">
                        <span className="top">Status</span>
                        {alerta.status === "pendente" ? (
                          <span className="Statusalert">
                            Aguardando análise
                          </span>
                        ) : (
                          <span className="Statusalert">Em manutenção</span>
                        )}
                      </div>
                      <div className="Status">
                        <span className="top">Alerta</span>
                        <p> {alerta.descricao}</p>
                      </div>
                      <div className="Status">
                        <span className="top">Tempo Decorrido</span>
                        <span>{tempoDecorrido}</span>
                      </div>
                      <div className="Status">
                        <span className="top">Atualizar</span>
                        {alerta.status === "pendente" ? (
                          <button
                            className="buttonPendente"
                            onClick={() => {
                              UpdateAlerta("em_progresso", alerta.id);
                            }}
                          >
                            Entrar Em manutenção
                          </button>
                        ) : (
                          <button
                            className="buttonProgresso"
                            onClick={() => {
                              UpdateAlerta("resolvido", alerta.id);
                            }}
                          >
                            Problema Resolvido
                          </button>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="alertsOk">
                <h2>Nenhum alerta ativo. Tudo certo!</h2>
              </div>
            )}
          </section>
        ) : (
          <section className="historicoAlert">
            <ul className="ulHistorico">
              {alerEmergenciaListHistorico.map((alerta) => {
                return (
                  <li>
                    <span className="iconStyled">
                      <AiOutlineAlert />
                    </span>
                    <div className="Status">
                      <span className="top">Status</span>
                      <span>Resolvido</span>
                    </div>
                    <div className="Status">
                      <span className="top">Alerta</span>
                      <p> {alerta.descricao}</p>
                    </div>
                    <div className="Status">
                      <span className="top"> Início do Erro</span>
                      <span>
                        {new Date(alerta.createdAt).toLocaleString("pt-BR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>

                    <div className="Status">
                      <span className="top"> Data de Solução</span>
                      <span>
                        {new Date(alerta.updatedAt).toLocaleString("pt-BR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </section>
        )}
      </div>
    </ModalStyledAvisoEmergencia>
  );
};

export const Modalrelatorio = ({ bombaId, data }) => {
  const { modalReladorioBombaOn, setModalRelatorioBombaOn } =
    useContext(ElevatoriaContext);
  const { headerApi } = useContext(HomeContext);
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mesSelecionado, setMesSelecionado] = useState(
    new Date().getMonth() + 1
  ); // 1-12
  const [anoSelecionado, setAnoSelecionado] = useState(
    new Date().getFullYear()
  );

  const meses = [
    { nome: "Janeiro", valor: 1 },
    { nome: "Fevereiro", valor: 2 },
    { nome: "Março", valor: 3 },
    { nome: "Abril", valor: 4 },
    { nome: "Maio", valor: 5 },
    { nome: "Junho", valor: 6 },
    { nome: "Julho", valor: 7 },
    { nome: "Agosto", valor: 8 },
    { nome: "Setembro", valor: 9 },
    { nome: "Outubro", valor: 10 },
    { nome: "Novembro", valor: 11 },
    { nome: "Dezembro", valor: 12 },
  ];

  const anos = [2023, 2024, 2025]; // Você pode gerar isso dinamicamente se quiser

  const getRelatorio = async () => {
    const year = data.getFullYear();
    const month = String(data.getMonth() + 1).padStart(2, "0");
    const day = String(data.getDate()).padStart(2, "0");
    setLoading(true);
    try {
      const response = await apiSae.get(
        `bomba/registro/leitura/${bombaId}/${year}-${month}-${day}`,
        headerApi
      );
      setRelatorio(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatarTempo = (segundos) => {
    // Calculando horas, minutos e segundos
    const horas = Math.floor(segundos / 3600);
    segundos %= 3600;
    const minutos = Math.floor(segundos / 60);
    segundos %= 60;

    // Se o número de horas for maior que 0, mostramos em horas
    if (horas > 0) {
      return `${horas} hora${horas > 1 ? "s" : ""} ${minutos} minuto${
        minutos !== 1 ? "s" : ""
      }`;
    } else if (minutos > 0) {
      // Se não houver horas, mostramos apenas minutos
      return `${minutos} minuto${minutos !== 1 ? "s" : ""}`;
    } else {
      // Caso sejam menos de 60 segundos
      return `${segundos} segundo${segundos !== 1 ? "s" : ""}`;
    }
  };

  const mediaPorAcionamento = (
    numeroAcionamentos,
    totalSegundosTrabalhados
  ) => {
    if (numeroAcionamentos > 0) {
      const mediaSegundos = totalSegundosTrabalhados / numeroAcionamentos;
      const minutos = Math.floor(mediaSegundos / 60);
      const segundos = Math.floor(mediaSegundos % 60);
      return `${minutos}m ${segundos}s`;
    } else {
      return "0s";
    }
  };

  const generateReport = async (formatType) => {
    const tableColumn = [
      "Data",
      "Acionamentos",
      "horímetro do dia",
      "Média de tempo de funcionamento",
    ];

    const relatorioTotal = await apiSae.get(
      `/bomba/registro/leitura-mensal/${bombaId}/${mesSelecionado}/${anoSelecionado}`,
      headerApi
    );

    // Mapeia os dados do histórico para as linhas da tabela
    const tableRows = relatorioTotal.data
      .slice()
      .map((item) => [
        format(new Date(item.dataRegistro), "yyyy-MM-dd"),
        item.statusOff,
        formatarTempo(item.totalHorasTrabalhadas),
        mediaPorAcionamento(item.statusOff, item.totalHorasTrabalhadas),
      ]);

    if (formatType === "pdf") {
      // Criar um documento PDF em orientação paisagem ('l' para landscape)
      const doc = new jsPDF("l");
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        styles: {
          lineColor: [0, 0, 0], // Cor da linha, definida como preta
          lineWidth: 0.2, // Espessura da linha
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // ajuste conforme necessário para outras colunas
        },
        theme: "grid", // Usar o tema 'grid' que inclui linhas verticais
      });
      doc.save(
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado}.pdf`
      );
    } else if (formatType === "csv") {
      // Gerar o conteúdo CSV como string
      const headers = tableColumn.join(",") + "\n";
      const csvRows = tableRows.map((row) => row.join(",")).join("\n");
      const csvString = headers + csvRows;

      // Criar um blob para o CSV e iniciar o download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado} .csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    getRelatorio();
  }, []);

  return (
    <ModalRelatorioBombaStyled>
      <div className="Conteiner">
        <span
          className="closeModal"
          onClick={() => setModalRelatorioBombaOn(false)}
        >
          <IoMdCloseCircleOutline />
        </span>
        <h3>
          Relatório de Funcionamento da Bomba {data.getDate()}-
          {data.getMonth() + 1 <= 9
            ? `0${data.getMonth() + 1}`
            : data.getMonth() + 1}
        </h3>
        {relatorio ? (
          <ul>
            <li>
              <p>Horas em Funcionamento no Dia: </p>
              <div>
                <span className="resultsModal">
                  {formatarTempo(relatorio.totalHorasTrabalhadas)}
                </span>
              </div>
            </li>

            <li>
              <p>Média de tempo de funcionamento da bomba: </p>
              <div>
                <span className="resultsModal">
                  {mediaPorAcionamento(
                    relatorio.statusOff,
                    relatorio.totalHorasTrabalhadas
                  )}
                </span>
              </div>
            </li>
            <li>
              <p>Número total de acionamentos da bomba: </p>
              <div className="resultsModal">
                <span>{relatorio.statusOn}</span>
              </div>
            </li>
            <div className="selectRelatorio">
              <div>
                <label>Mês: </label>
                <select
                  value={mesSelecionado}
                  onChange={(e) => setMesSelecionado(Number(e.target.value))}
                >
                  {meses.map((mes) => (
                    <option key={mes.valor} value={mes.valor}>
                      {mes.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label>Ano: </label>
                <select
                  value={anoSelecionado}
                  onChange={(e) => setAnoSelecionado(Number(e.target.value))}
                >
                  {anos.map((ano) => (
                    <option key={ano} value={ano}>
                      {ano}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="buttonsRelatorio">
              <button
                onClick={() => {
                  generateReport("csv");
                }}
              >
                Download CSV
              </button>
              <button
                onClick={() => {
                  generateReport("pdf");
                }}
              >
                Download PDF
              </button>
            </div>
          </ul>
        ) : (
          <div className="noRelatorio">
            <span> Bomba nao possui relatorio desse dia </span>
          </div>
        )}
      </div>
    </ModalRelatorioBombaStyled>
  );
};

const ModalAtivacteRevese = ({ idBomba, status }) => {
  const { reversoOn, setReversoOn } = useContext(ElevatoriaContext);
  const { headerApi } = useContext(HomeContext);

  const atualizaReverso = async () => {
    const statusReverso = {
      reverso: !status,
    };

    try {
      const response = await apiSae.patch(
        `bomba/${idBomba}`,
        statusReverso,
        headerApi
      );
    } catch (error) {
      console.log(error);
    } finally {
      setReversoOn(false);
    }
  };

  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>Tem certeza que deseja Mudar Sentido de rotação da Bomba?</h3>
        <div className="botao">
          <button
            onClick={() => {
              atualizaReverso();
            }}
          >
            Sim
          </button>
          <button className="botaoNao" onClick={() => setReversoOn(false)}>
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};

const ModalRodarRevese = ({ salveInf }) => {
  const { ligarReversoModal, ligarSetReversoModal } =
    useContext(ElevatoriaContext);
  const { headerApi } = useContext(HomeContext);

  const ligarBombaReverso = async () => {
    let dados;

    if (salveInf[2] === 1) {
      dados = {
        status: 0,
      };
    } else {
      dados = {
        status: 1,
      };
    }

    try {
      const response = await apiSae.post(
        `bomba/Reverse/${salveInf[0]}`,
        dados,
        headerApi
      );
    } catch (error) {
      console.log(error);
    } finally {
      ligarSetReversoModal(false);
    }
  };

  return (
    <ModalsConfirmeStyled>
      <div className="blocoConfirma">
        <h3>{`Tem certeza quer ${
          salveInf[2] === 1 ? "Desligar" : "Ligar"
        } bomba no sentido Reverso ? ⚠️`}</h3>
        <div className="botao">
          <button
            onClick={() => {
              ligarBombaReverso();
            }}
          >
            Sim
          </button>
          <button
            className="botaoNao"
            onClick={() => ligarSetReversoModal(false)}
          >
            Não
          </button>
        </div>
      </div>
    </ModalsConfirmeStyled>
  );
};

const ModalRelatorios = ({ elevatoria }) => {
  const {
    setModalRelatoriosOn,
    idDataPoco,
    selectedDate,
    setSelectedDate,
    setDataPoco,
    dataPoco,
    selectedDateBomba,
    setSelectedDateBomba,
    loading,
    setLoading,
  } = useContext(ElevatoriaContext);
  const { headerApi } = useContext(HomeContext);

  const [selectRelatorio, setSelectRelatorio] = useState("Poco");
  const [opcaoSelecionada, setOpcaoSelecionada] = useState("dia");

  const handleDateChange = (date) => {
    setSelectedDate(date);

    setDataPoco((prevDataPoco) => {
      const index = prevDataPoco.findIndex(
        (item) => item.id_poco === idDataPoco
      );

      if (index !== -1) {
        const updatedDataPoco = [...prevDataPoco];
        updatedDataPoco[index] = { ...updatedDataPoco[index], data: date };
        return updatedDataPoco;
      } else {
        return [...prevDataPoco, { id_poco: idDataPoco, data: date }];
      }
    });
  };

  const generateReport = async (formatType) => {
    const tableColumn = ["Data", "Hora", "Nivel"];

    const dataFormatada =
      dataPoco && dataPoco[0]?.data
        ? format(new Date(dataPoco[0].data), "dd-MM-yyyy")
        : format(new Date(), "dd-MM-yyyy");

    const relatorioTotal = await apiSae.get(
      `historico/poco/data/${idDataPoco}/${dataFormatada}/${opcaoSelecionada}`,
      headerApi
    );

    // Mapeia os dados do histórico para as linhas da tabela
    const tableRows = relatorioTotal.data
      .slice()
      .reverse()
      .map((item) => [
        format(new Date(item.timestamp), "yyyy-MM-dd"),
        format(new Date(item.timestamp), "HH:mm"),
        item.nivel_atual,
      ]);

    if (formatType === "pdf") {
      // Criar um documento PDF em orientação paisagem ('l' para landscape)
      const doc = new jsPDF("l");
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        styles: {
          lineColor: [0, 0, 0], // Cor da linha, definida como preta
          lineWidth: 0.2, // Espessura da linha
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // ajuste conforme necessário para outras colunas
        },
        theme: "grid", // Usar o tema 'grid' que inclui linhas verticais
      });
      doc.save(`Relatório_de_NIvel.${format(new Date(), "yyyy-MM-dd")}.pdf`);
    } else if (formatType === "csv") {
      // Gerar o conteúdo CSV como string
      const headers = tableColumn.join(",") + "\n";
      const csvRows = tableRows.map((row) => row.join(",")).join("\n");
      const csvString = headers + csvRows;

      // Criar um blob para o CSV e iniciar o download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Relatório_de_NIvel${format(new Date(), "yyyy-MM-dd")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // ACINAMENTOS
  const [relatorio, setRelatorio] = useState(null);
  const [mesSelecionado, setMesSelecionado] = useState(
    new Date().getMonth() + 1
  ); // 1-12
  const [anoSelecionado, setAnoSelecionado] = useState(
    new Date().getFullYear()
  );

  const [bombaId, setBombaId] = useState(null);
  const [bombaSelecionada, setBombaSelecionada] = useState(null);

  const meses = [
    { nome: "Janeiro", valor: 1 },
    { nome: "Fevereiro", valor: 2 },
    { nome: "Março", valor: 3 },
    { nome: "Abril", valor: 4 },
    { nome: "Maio", valor: 5 },
    { nome: "Junho", valor: 6 },
    { nome: "Julho", valor: 7 },
    { nome: "Agosto", valor: 8 },
    { nome: "Setembro", valor: 9 },
    { nome: "Outubro", valor: 10 },
    { nome: "Novembro", valor: 11 },
    { nome: "Dezembro", valor: 12 },
  ];

  const anos = [2023, 2024, 2025]; // Você pode gerar isso dinamicamente se quiser

  const getRelatorio = async (bombasID, dataCalentadrio) => {
    setLoading(true);

    const year = dataCalentadrio.getFullYear();
    const month = String(dataCalentadrio.getMonth() + 1).padStart(2, "0");
    const day = String(dataCalentadrio.getDate()).padStart(2, "0");

    try {
      const response = await apiSae.get(
        `bomba/registro/leitura/${bombasID}/${year}-${month}-${day}`,
        headerApi
      );
      setRelatorio(response.data);
    } catch (error) {
      if (error.response.status === 404) {
        setRelatorio(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const formatarTempo = (segundos) => {
    // Calculando horas, minutos e segundos
    const horas = Math.floor(segundos / 3600);
    segundos %= 3600;
    const minutos = Math.floor(segundos / 60);
    segundos %= 60;

    // Se o número de horas for maior que 0, mostramos em horas
    if (horas > 0) {
      return `${horas} hora${horas > 1 ? "s" : ""} ${minutos} minuto${
        minutos !== 1 ? "s" : ""
      }`;
    } else if (minutos > 0) {
      // Se não houver horas, mostramos apenas minutos
      return `${minutos} minuto${minutos !== 1 ? "s" : ""}`;
    } else {
      // Caso sejam menos de 60 segundos
      return `${segundos} segundo${segundos !== 1 ? "s" : ""}`;
    }
  };

  const mediaPorAcionamento = (
    numeroAcionamentos,
    totalSegundosTrabalhados
  ) => {
    if (numeroAcionamentos > 0) {
      const mediaSegundos = totalSegundosTrabalhados / numeroAcionamentos;
      const minutos = Math.floor(mediaSegundos / 60);
      const segundos = Math.floor(mediaSegundos % 60);
      return `${minutos}m ${segundos}s`;
    } else {
      return "0s";
    }
  };

  const generateReportAcionamneto = async (formatType) => {
    const tableColumn = [
      "Data",
      "Acionamentos",
      "horímetro do dia",
      "Média de tempo de funcionamento",
      "Vazão do dia",
      "Vazão",
      "Desgaste da Bomba",
    ];

    const relatorioTotal = await apiSae.get(
      `/bomba/registro/leitura-mensal/${bombaId}/${mesSelecionado}/${anoSelecionado}`,
      headerApi
    );

    // Mapeia os dados do histórico para as linhas da tabela
    const tableRows = relatorioTotal.data
      .slice()
      .map((item) => [
        format(new Date(item.dataRegistro), "yyyy-MM-dd"),
        item.statusOff,
        formatarTempo(item.totalHorasTrabalhadas),
        mediaPorAcionamento(item.statusOff, item.totalHorasTrabalhadas),
        calcularVolumeTotal(
          bombaSelecionada.vazaoNominal_Ls,
          item.totalHorasTrabalhadas,
          item.desgaste
        ),
        calcularVazaoCorrigida(bombaSelecionada.vazaoNominal_Ls, item.desgaste),
        item.desgaste,
      ]);

    if (formatType === "pdf") {
      // Criar um documento PDF em orientação paisagem ('l' para landscape)
      const doc = new jsPDF("l");
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 20,
        styles: {
          lineColor: [0, 0, 0], // Cor da linha, definida como preta
          lineWidth: 0.2, // Espessura da linha
        },
        columnStyles: {
          0: { cellWidth: "auto" }, // ajuste conforme necessário para outras colunas
        },
        theme: "grid", // Usar o tema 'grid' que inclui linhas verticais
      });
      doc.save(
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado}.pdf`
      );
    } else if (formatType === "csv") {
      // Gerar o conteúdo CSV como string
      const headers = tableColumn.join(",") + "\n";
      const csvRows = tableRows.map((row) => row.join(",")).join("\n");
      const csvString = headers + csvRows;

      // Criar um blob para o CSV e iniciar o download
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Relatório_de_Funcionamento_Bomba ${
          meses[mesSelecionado - 1].nome
        } ${anoSelecionado} .csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleDateChangeAcinamentos = (date) => {
    setSelectedDateBomba(date);
    getRelatorio(bombaId, date);
  };

  const calcularVolumeTotal = (
    vazaoNominal_Ls,
    totalSegundosTrabalhados,
    desgastePercentual
  ) => {
    // 1) Ajusta vazão pelo desgaste
    const vazaoReal_Ls = vazaoNominal_Ls * (1 - desgastePercentual / 100);

    // 2) Volume em litros = L/s * s
    const volumeLitros = vazaoReal_Ls * totalSegundosTrabalhados;

    // 3) Converter para m³ (1 m³ = 1000 L) e arredondar
    const volumeM3 = volumeLitros / 1000;
    return parseFloat(volumeM3.toFixed(1));
  };

  const calcularVazaoCorrigida = (vazaoNominal_Ls, desgastePercentual) => {
    const vazaoCorrigida = vazaoNominal_Ls * (1 - desgastePercentual / 100);
    return parseFloat(vazaoCorrigida.toFixed(1));
  };

  useEffect(() => {
    setBombaId(elevatoria.pocos[0].bombas[0].id);
    getRelatorio(elevatoria.pocos[0].bombas[0].id, selectedDateBomba);
  }, [elevatoria]);

  useEffect(() => {
    setBombaSelecionada(
      elevatoria.pocos[0].bombas.find((bomba) => bomba.id === bombaId)
    );
  }, [bombaId]);

  return (
    <ModalRelatoriosStyled>
      <div className="conteiner">
        <span
          className="closeModal"
          onClick={() => setModalRelatoriosOn(false)}
        >
          <IoMdCloseCircleOutline />
        </span>
        <nav className="barSelect">
          <ul className="ulconteiner">
            <li
              className={selectRelatorio === "Poco" ? "select" : ""}
              onClick={() => setSelectRelatorio("Poco")}
            >
              Poço
            </li>
            <li
              className={selectRelatorio === "Acionamentos" ? "select" : ""}
              onClick={() => setSelectRelatorio("Acionamentos")}
            >
              Acionamentos
            </li>
            <li
              className={selectRelatorio === "Bombas" ? "select" : "desativar"}
              // onClick={() => setSelectRelatorio("Bombas")}
            >
              Bombas
            </li>
          </ul>
        </nav>

        {selectRelatorio === "Poco" && (
          <section className="PocoRelatorio">
            <div className="DataPoco">
              <h2>Selecionar Data</h2>
              <DatePicker
                className="agenda"
                selected={selectedDate}
                onChange={handleDateChange}
                inline
              />
              <div className="selectRelatorio">
                <label>Período do histórico: </label>
                <select
                // value={opcaoSelecionada} onChange={handleChange}
                >
                  <option value="dia">Dia</option>
                  <option value="mes">Mês</option>
                  <option value="ano">Ano</option>
                </select>
              </div>
              <div className="buttonsRelatorio">
                <button
                  onClick={() => {
                    generateReport("csv");
                  }}
                >
                  Download CSV
                </button>
                <button
                  onClick={() => {
                    generateReport("pdf");
                  }}
                >
                  Download PDF
                </button>
              </div>
            </div>
            <div className="GraficoPoco">
              <GraficoPoco
                idPoco={idDataPoco}
                altura={elevatoria.pocos[0].altura_poco}
              />
            </div>
          </section>
        )}
        {selectRelatorio === "Acionamentos" && (
          <section className="AcionamentosRelatorio">
            <div className="selecBombas">
              <nav>
                <ul className="navBombas">
                  {elevatoria.pocos[0].bombas.map((bomba, index) => {
                    return (
                      <li
                        className={bomba.id == bombaId ? "selectButton" : ""}
                        onClick={() => {
                          getRelatorio(bomba.id, selectedDateBomba);
                          setBombaId(bomba.id);
                        }}
                      >
                        Bomba {index + 1}
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
            <div className="ConteinerAcinamesntos">
              <h3>
                Relatório de Funcionamento da Bomba{" "}
                {selectedDateBomba.getDate()}-
                {selectedDateBomba.getMonth() + 1 <= 9
                  ? `0${selectedDateBomba.getMonth() + 1}`
                  : selectedDateBomba.getMonth() + 1}
              </h3>
              <div className="infoRelatorio">
                <div className="calendario">
                  <DatePicker
                    className="agenda"
                    selected={selectedDateBomba}
                    onChange={handleDateChangeAcinamentos}
                    inline
                  />
                </div>
                {relatorio ? (
                  <ul>
                    <li>
                      <p>
                        Horas em Funcionamento no Dia:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Total de horas que a bomba trabalhou na data
                            selecionada.
                          </span>
                        </span>
                      </p>
                      <div>
                        <span className="resultsModal">
                          {formatarTempo(relatorio.totalHorasTrabalhadas)}
                        </span>
                      </div>
                    </li>

                    <li>
                      <p>
                        Média de tempo de funcionamento da bomba:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Média de tempo que a bomba ficou ligada em cada
                            acionamento durante o dia.
                          </span>
                        </span>
                      </p>
                      <div>
                        <span className="resultsModal">
                          {mediaPorAcionamento(
                            relatorio.statusOff,
                            relatorio.totalHorasTrabalhadas
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Número total de acionamentos da bomba:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Quantidade de vezes que a bomba foi ligada na data
                            selecionada.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>{relatorio.statusOn}</span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Vazão do dia:
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Volume total de água bombeado no dia, considerando o
                            tempo de funcionamento e o desgaste da bomba.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>
                          {calcularVolumeTotal(
                            bombaSelecionada.vazaoNominal_Ls,
                            relatorio.totalHorasTrabalhadas,
                            relatorio.desgaste
                          )}
                          m³
                        </span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Vazão
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Vazão atual da bomba em litros por segundo (L/s),
                            ajustada com base no desgaste de desempenho.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>
                          {calcularVazaoCorrigida(
                            bombaSelecionada.vazaoNominal_Ls,
                            relatorio.desgaste
                          )}
                          .L/s
                        </span>
                      </div>
                    </li>
                    <li>
                      <p>
                        Desgaste
                        <span className="tooltip">
                          <AiTwotoneQuestionCircle />
                          <span className="tooltip-text">
                            Desgaste da bomba em percentual (%), indicando a
                            redução na eficiência da bomba devido ao uso e
                            desgaste ao longo do tempo.
                          </span>
                        </span>
                      </p>
                      <div className="resultsModal">
                        <span>{relatorio.desgaste}%</span>
                      </div>
                    </li>
                    <div className="selectRelatorio">
                      <div>
                        <label>Mês: </label>
                        <select
                          value={mesSelecionado}
                          onChange={(e) =>
                            setMesSelecionado(Number(e.target.value))
                          }
                        >
                          {meses.map((mes) => (
                            <option key={mes.valor} value={mes.valor}>
                              {mes.nome}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label>Ano: </label>
                        <select
                          value={anoSelecionado}
                          onChange={(e) =>
                            setAnoSelecionado(Number(e.target.value))
                          }
                        >
                          {anos.map((ano) => (
                            <option key={ano} value={ano}>
                              {ano}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="buttonsRelatorio">
                      <button
                        onClick={() => {
                          generateReportAcionamneto("csv");
                        }}
                      >
                        Download CSV
                      </button>
                      <button
                        onClick={() => {
                          generateReportAcionamneto("pdf");
                        }}
                      >
                        Download PDF
                      </button>
                    </div>
                  </ul>
                ) : (
                  <div className="noRelatorio">
                    <span> Bomba nao possui relatorio desse dia </span>
                  </div>
                )}
              </div>
            </div>
          </section>
        )}

        <section></section>
      </div>
    </ModalRelatoriosStyled>
  );
};
